import React from 'react';
import { Routes, Route } from "react-router-dom";
import CheckerReportsModule from "./rr-checker-reports-module/checker-reports-module";

const RRCheckerReports = () => {
  return (
    <Routes>
      <Route index element={<CheckerReportsModule />} />
    </Routes>
  )
}

export default RRCheckerReports;



